import Vue from 'vue';
import { Button } from 'vant';
import { Toast } from 'vant';
Vue.use(Button);

import { Form } from 'vant';
import { Field } from 'vant';

Vue.use(Form);
Vue.use(Field);

import { Tabbar, TabbarItem } from 'vant';

Vue.use(Tabbar);
Vue.use(TabbarItem);


import { Grid, GridItem } from 'vant';

Vue.use(Grid);
Vue.use(GridItem);
import { NoticeBar } from 'vant';

Vue.use(NoticeBar);

import { Picker } from 'vant';

Vue.use(Picker);

import { Popup } from 'vant';

Vue.use(Popup);

import { Checkbox, CheckboxGroup } from 'vant';

Vue.use(Checkbox);
Vue.use(CheckboxGroup);
import { Image as VanImage } from 'vant';

Vue.use(VanImage);

import { RadioGroup, Radio } from 'vant';

Vue.use(Radio);
Vue.use(RadioGroup);
import { Divider } from 'vant';

Vue.use(Divider);
import { Step, Steps } from 'vant';

Vue.use(Step);
Vue.use(Steps);
import { List } from 'vant';

Vue.use(List);
import { Cell, CellGroup } from 'vant';

Vue.use(Cell);
Vue.use(CellGroup);
import { Card } from 'vant';

Vue.use(Card);
import { Tag } from 'vant';

Vue.use(Tag);

import { Empty } from 'vant';

Vue.use(Empty)
// import { Toast } from 'vant';
//
// Vue.use(Toast);
// import { Icon } from 'vant';
//
// Vue.use(Icon);